

/**
 * Open Modal javascript trigger
 */
function openModal(modal, opener){
  if(modal && typeof modal.show === 'function') {
    try {
      modal.show(opener);
    } catch (err) {
      console.error('Modal open error:', err);
    }
  }
}
/**
* background Overlay
*/
class SiteOverlay extends HTMLElement{
  constructor() {
    super();
    this.overlayElement = Utility.DomSelector.byId('site-overlay');
    this.bindEvents();
  }

  /**
   * bind Click and Touchend event to this custom component
   */
  bindEvents(){
    this.addEventListener('click', this.onClick.bind(this));
    this.addEventListener('touchend', this.onClick.bind(this));
  }

  /**
   * Click event of Site overlay
   */
  onClick(){
    SiteOverlay.hideOverlay();
  }

  /**
   * Show Overlay
   * @returns {boolean} Returns true if overlay was shown, false if already visible
   */
   static showOverlay(){
    const overlay = Utility.DomSelector.byId('site-overlay');
    if (overlay.classList.contains('overlay--body')) {
      return false; // Already visible
    }
    
    Utility.CSS.add(overlay, 'overlay--body');
    overlay.setAttribute('aria-hidden', 'true');
    Utility.CSS.add(document.body, 'scroll-fixed');
    
    // Make background content inert (prevents focus and interaction)
    // const mainContent = Utility.DomSelector.$('main');
    // const header = Utility.DomSelector.$('header');
    // if (mainContent) mainContent.setAttribute('inert', '');
    // if (header) header.setAttribute('inert', '');
    
    return true; // Successfully shown
  }

  /**
   * Hide overlay
   * @returns {boolean} Returns true if overlay was hidden, false if already hidden
   */
  static hideOverlay(){
    const overlay = Utility.DomSelector.byId('site-overlay');
    if (!overlay.classList.contains('overlay--body')) {
      return false; // Already hidden
    }
    
    const openDrawers = Utility.DomSelector.$$('custom-drawer.open');
    openDrawers.forEach(drawer => {
      drawer.closeDrawer();
    });
    
    Utility.CSS.remove(overlay, 'overlay--body');
    Utility.CSS.remove(document.body, 'scroll-fixed');
    
    // Remove inert from background content
    // const mainContent = Utility.DomSelector.$('main');
    // const header = Utility.DomSelector.$('header');
    // if (mainContent) mainContent.removeAttribute('inert');
    // if (header) header.removeAttribute('inert');
    
    return true; // Successfully hidden
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.onClick.bind(this));
    this.removeEventListener('touchend', this.onClick.bind(this));
  }
}
customElements.define("site-overlay", SiteOverlay, {
  once: true
});

/**
* Modal Dialogue
*
*/
class ModalDialog extends HTMLElement {
  constructor() {
    super();

    this.isOpen = false;
    this.modal = Utility.DomSelector.$('.modal', this);
    this.modalOpeners = Utility.DomSelector.$$(`[data-modal-opener="${this.id}"]`);
    this.closeBtn = Utility.DomSelector.$('[id^="ModalClose-"]', this);

    this.setAttribute('aria-hidden', 'true');
    this.setAttribute('inert', '');
  }

  connectedCallback() {
    this.modalOpeners.forEach((opener)=>{
      opener.addEventListener('click', (evt)=>{
        evt.preventDefault();
        this.show(opener);
      });
    });

    if (this.closeBtn) {
      this.closeBtn.addEventListener('click', this.hide.bind(this));
    }

    this.addEventListener('click', (evt) => {
      if (evt.target === this) this.hide();
    });

    this.addEventListener('keyup', (evt) => {
      if (evt.code && evt.code.toUpperCase() === 'ESCAPE') this.hide();
    });
  }

  // Clean up event listeners
  disconnectedCallback() {
    this.isOpen = false;

    this.modalOpeners.forEach((opener) => {
      opener.removeEventListener('click', this.show.bind(this));
    });

    if (this.closeBtn) {
      this.closeBtn.removeEventListener('click', this.hide.bind(this));
    }

    this.removeEventListener('click', this.hide);
    this.removeEventListener('keyup', this.hide);
  }

  /**
   * Open the Modal
   * @param {element} opener 
   * @returns {ModalDialog} Returns this for method chaining
   */
  show(opener) {
    if (this.isOpen) return this; // Prevent opening if already open

    this.isOpen = true;
    this.openedBy = opener;
    Utility.CSS.add(this.modal, 'open');
    this.removeAttribute('inert');
    this.setAttribute('aria-hidden', 'false');

    SiteOverlay.showOverlay();
    
    // Announce modal opening with specific name
    const modalName = this.getAttribute('aria-label') || 'Modal Dialogue';
    Utility.announceToScreenReader(`${modalName} modal opened`);
    
    Utility.Focus.trap(this, this.closeBtn);
    
    return this; // Enable method chaining
  }

  /**
   * Close Modal Dialogue
   * @returns {ModalDialog} Returns this for method chaining
   */
  hide() {
    if (!this.isOpen) return this; // Prevent closing if already closed

    this.isOpen = false;
    Utility.CSS.remove(this.modal, 'open');
    this.setAttribute('inert', '');
    this.setAttribute('aria-hidden', 'true');

    SiteOverlay.hideOverlay();
    
    // Announce modal closing with specific name
    const modalName = this.getAttribute('aria-label') || 'Modal Dialogue';
    Utility.announceToScreenReader(`${modalName} modal closed`);
    
    Utility.Focus.release(this.openedBy);
    if(this.id == 'PopupModal-video') {
      Utility.DomSelector.$('.video-container', this).innerHTML = '';
    }
    
    return this; // Enable method chaining
  }
}
customElements.define('modal-dialog', ModalDialog);

/**
 * Custom Drawer Component
 * A flexible drawer component that slides in from various positions
 * @extends HTMLElement
 */
class CustomDrawer extends HTMLElement {
  constructor() {
    super();
    
    this.isOpen = false;
    this.openedBy = null;
    this.toggleDrawer = Utility.DomSelector.$$(`[data-toggleDrawer="${this.id}"]`);
    this.closeButtons = Utility.DomSelector.$$('[data-closedrawer]', this);
    this.forceFocus = Utility.DomSelector.$('h2, [tabindex="0"]', this) || 
                     Utility.DomSelector.$('button, a, input', this);
    
    // Set initial ARIA attributes
    this.setAttribute('aria-hidden', 'true');
    this.setAttribute('inert', '');
  }

  connectedCallback() {
    // Bind toggle drawer triggers
    this.toggleDrawer.forEach((trigger) => {
      trigger.addEventListener('click', (evt) => {
        evt.preventDefault();
        if (this.isOpen) {
          this.closeDrawer();
        } else {
          this.openDrawer(trigger);
        }
      });
    });

    // Bind close buttons
    this.closeButtons.forEach((btn) => {
      btn.addEventListener('click', () => {
        this.closeDrawer();
      });
    });

    // Close on Escape key
    this.addEventListener('keyup', (evt) => {
      if (evt.code && evt.code.toUpperCase() === 'ESCAPE' && this.isOpen) {
        this.closeDrawer();
      }
    });
  }

  disconnectedCallback() {
    this.toggleDrawer.forEach((trigger) => {
      trigger.removeEventListener('click', this.openDrawer);
    });
    
    this.closeButtons.forEach((btn) => {
      btn.removeEventListener('click', this.closeDrawer);
    });
    
    this.removeEventListener('keyup', this.closeDrawer);
  }

  /**
   * Open the drawer
   * @param {HTMLElement} opener - Element that triggered the drawer
   * @returns {CustomDrawer} Returns this for method chaining
   */
  openDrawer(opener) {
    if (this.isOpen) return this;

    this.isOpen = true;
    this.openedBy = opener;
    
    // Close other drawers first
    this.resetOtherDrawers();
    
    // Show drawer
    Utility.CSS.add(this, 'open');
    this.removeAttribute('inert');
    this.setAttribute('aria-hidden', 'false');
    
    // Show overlay
    SiteOverlay.showOverlay();
    
    // Trap focus
    Utility.Focus.trap(this, this.forceFocus);
    
    // Announce to screen reader
    const drawerName = this.getAttribute('aria-label') || 'Drawer';
    Utility.announceToScreenReader(`${drawerName} drawer opened`);
    
    // Dispatch custom event
    this.dispatchEvent(new CustomEvent('drawer:opened', { bubbles: true }));
    
    return this;
  }

  /**
   * Close the drawer
   * @returns {CustomDrawer} Returns this for method chaining
   */
  closeDrawer() {
    if (!this.isOpen) return this;

    this.isOpen = false;
    
    // Hide drawer
    Utility.CSS.remove(this, 'open');
    this.setAttribute('inert', '');
    this.setAttribute('aria-hidden', 'true');
    
    // Hide overlay (only if no other drawers are open)
    const otherOpenDrawers = Utility.DomSelector.$$('custom-drawer.open');
    if (otherOpenDrawers.length === 0) {
      SiteOverlay.hideOverlay();
    }
    
    // Release focus trap and return focus
    Utility.Focus.release(this.openedBy);
    
    // Announce to screen reader
    const drawerName = this.getAttribute('aria-label') || 'Drawer';
    Utility.announceToScreenReader(`${drawerName} drawer closed`);
    
    // Dispatch custom event
    this.dispatchEvent(new CustomEvent('drawer:closed', { bubbles: true }));
    
    this.openedBy = null;
    
    return this;
  }

  /**
   * Close all other open drawers
   * @returns {CustomDrawer} Returns this for method chaining
   */
  resetOtherDrawers() {
    const allDrawers = Utility.DomSelector.$$('custom-drawer');
    allDrawers.forEach((drawer) => {
      if (drawer !== this && drawer.isOpen) {
        drawer.closeDrawer();
      }
    });
    return this;
  }

  /**
   * Hide open panels/dropdowns inside drawer
   * @returns {CustomDrawer} Returns this for method chaining
   */
  hideOpenPanels() {
    const openPanels = Utility.DomSelector.$$('.open, [aria-expanded="true"]', this);
    openPanels.forEach((panel) => {
      Utility.CSS.remove(panel, 'open');
      panel.setAttribute('aria-expanded', 'false');
    });
    return this;
  }
}

// Register custom element
customElements.define('custom-drawer', CustomDrawer);

/**
 * Individual Toast Notification Element
 * Represents a single toast notification instance
 * @extends HTMLElement
 */
class ToastNotification extends HTMLElement {
  /**
   * Constructor - Initialize toast notification properties
   */
  constructor() {
    super();

    // DOM element references (initialized after innerHTML is set)
    this.container = null;
    this.closeBtn = null;
    this.progressBar = null;
    
    // Animation state
    this.animationFrameId = null; // Request ID from requestAnimationFrame
    this.animationCallback = null; // Animation function reference
    
    // Unique identifier for this toast
    this.toastId = `toast-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
    
    // Close button click handler (bound for proper cleanup)
    this.boundHandleClose = this.hide.bind(this);
  }

  /**
   * Initialize DOM element references
   * Called after innerHTML is set and element is connected to DOM
   * @private
   */
  _initializeElements() {
    if (!this.container) {
      this.container = Utility.DomSelector.$('.snotifyToast', this);
      this.closeBtn = Utility.DomSelector.$('.snotifyToast__close', this);
      this.progressBar = Utility.DomSelector.$('[data-toast-pr]', this);
      
      // Set ARIA role for accessibility
      if (this.container) {
        this.container.setAttribute('role', 'alert');
      }
    }
  }

  /**
   * Lifecycle callback - Called when element is added to DOM
   */
  connectedCallback() {
    // Initialize DOM references when connected
    this._initializeElements();
    
    // Attach close button event listener
    if (this.closeBtn) {
      this.closeBtn.addEventListener('click', this.boundHandleClose);
    }
  }

  /**
   * Lifecycle callback - Called when element is removed from DOM
   */
  disconnectedCallback() {
    // Remove event listeners
    if (this.closeBtn) {
      this.closeBtn.removeEventListener('click', this.boundHandleClose);
    }
    
    // Cancel any running animations
    this._cancelAnimation();
  }

  /**
   * Cancel any active animation frame
   * @private
   */
  _cancelAnimation() {
    if (this.animationFrameId !== null) {
      cancelAnimationFrame(this.animationFrameId);
      this.animationFrameId = null;
    }
    this.animationCallback = null;
  }

  /**
   * Show the toast notification with content
   * @param {string} title - Notification title text
   * @param {string} body - Notification body text
   * @param {object} options - Configuration options
   * @param {string} options.type - Notification type: 'success', 'error', 'warning', 'info'
   * @param {number} options.timeout - Auto-dismiss timeout in milliseconds
   * @returns {ToastNotification} Returns this for method chaining
   */
  show(title, body, options = {}) {
    // Ensure DOM elements are initialized
    this._initializeElements();
    
    // Validate container exists
    if (!this.container) {
      console.error('ToastNotification: Container element not found');
      return this;
    }

    // Update ARIA attributes for visibility
    this.setAttribute('aria-hidden', 'false');
    this.removeAttribute('inert');

    // Get notification type and timeout with defaults
    const type = options.type || 'info';
    const timeout = options.timeout || 5000;

    // Apply notification type class
    Utility.CSS.add(this.container, 'open', `snotify-${type}`);
    
    // Update title and body content
    const titleEl = Utility.DomSelector.$('.snotifyToast__title', this);
    const bodyEl = Utility.DomSelector.$('.snotifyToast__body', this);
    
    if (titleEl) {
      titleEl.textContent = title || '';
    }
    if (bodyEl) {
      bodyEl.textContent = body || '';
    }

    // Start auto-dismiss timer with progress bar
    this._manageToggle(timeout);
    
    return this;
  }

  /**
   * Manage auto-dismiss timer and progress bar animation
   * @param {number} timeout - Dismiss timeout in milliseconds
   * @private
   */
  _manageToggle(timeout) {
    // Get progress bar element
    if (!this.progressBar) {
      this.progressBar = Utility.DomSelector.$('[data-toast-pr]', this);
    }
    
    if (!this.progressBar) {
      return;
    }

    // Cancel any existing animation first
    this._cancelAnimation();

    // Calculate animation frames (60fps = 16.67ms per frame, divided by 2 for smoother animation)
    const totalFrames = Math.ceil(timeout / 16.67) / 2;
    let frame = 0;
    let width = 0;

    // Create animation callback function
    const animate = () => {
      width = (frame / totalFrames) * 100;
      
      if (this.progressBar) {
        this.progressBar.setAttribute('style', `width: ${width}%`);
      }
      
      if (frame < totalFrames) {
        frame++;
        // Request next frame and store the request ID
        this.animationFrameId = requestAnimationFrame(animate);
      } else {
        // Animation complete, hide the toast
        this.animationFrameId = null;
        this.animationCallback = null;
        this.hide();
      }
    };

    // Store callback reference for potential cancellation
    this.animationCallback = animate;
    
    // Start animation and store the request ID
    this.animationFrameId = requestAnimationFrame(animate);
  }

  /**
   * Hide and remove the toast notification
   * @returns {ToastNotification} Returns this for method chaining
   */
  hide() {
    // Cancel progress bar animation
    this._cancelAnimation();
    
    // Update ARIA attributes for hidden state
    this.setAttribute('aria-hidden', 'true');
    this.setAttribute('inert', '');

    // Ensure elements are initialized
    this._initializeElements();
    
    // Reset container classes
    if (this.container) {
      this.container.className = 'snotifyToast';
    }
    
    // Clear content
    const titleEl = Utility.DomSelector.$('.snotifyToast__title', this);
    const bodyEl = Utility.DomSelector.$('.snotifyToast__body', this);
    
    if (titleEl) {
      titleEl.textContent = '';
    }
    if (bodyEl) {
      bodyEl.textContent = '';
    }
    
    // Reset progress bar
    if (this.progressBar) {
      this.progressBar.removeAttribute('style');
    }

    // Notify parent container to remove from tracking array
    if (this.parentNode && typeof this.parentNode.removeToast === 'function') {
      this.parentNode.removeToast(this);
    }

    // Remove from DOM after slide-out animation completes
    setTimeout(() => {
      if (this.parentNode) {
        this.parentNode.removeChild(this);
      }
    }, 400);

    return this;
  }
}

/**
 * Toast Container - Manages multiple toast notifications
 * Handles creation, stacking, and removal of toast instances
 * @extends HTMLElement
 */
class ToastContainer extends HTMLElement {
  /**
   * Constructor - Initialize toast container
   */
  constructor() {
    super();
    
    // Array to track active toast instances
    this.toasts = [];
    
    // Maximum number of simultaneous toasts (oldest removed when limit reached)
    this.maxToasts = 5;
  }

  /**
   * Create and show a new toast notification
   * @param {string} title - Notification title text
   * @param {string} body - Notification body text
   * @param {object} options - Configuration options
   * @param {string} options.type - Notification type: 'success', 'error', 'warning', 'info'
   * @param {number} options.timeout - Auto-dismiss timeout in milliseconds
   * @returns {ToastNotification} The created toast instance
   */
  show(title, body, options = {}) {
    // Remove oldest toast if we've reached the maximum limit
    if (this.toasts.length >= this.maxToasts) {
      const oldestToast = this.toasts.shift();
      if (oldestToast && typeof oldestToast.hide === 'function') {
        oldestToast.hide();
      }
    }

    // Create new toast element
    const toast = this._createToastElement();
    
    // Append to DOM (triggers connectedCallback)
    this.appendChild(toast);
    
    // Track in array
    this.toasts.push(toast);

    // Show the toast with content (use setTimeout to ensure DOM is ready)
    setTimeout(() => {
      if (toast && typeof toast.show === 'function') {
        toast.show(title, body, options);
      }
    }, 0);

    // Update positioning for all toasts
    this._updatePositions();

    return toast;
  }

  /**
   * Create a new toast notification element with HTML structure
   * @returns {HTMLElement} Toast element ready to be appended to DOM
   * @private
   */
  _createToastElement() {
    // Create the custom element
    const toast = document.createElement('toast-notification');
    
    // Set ARIA attributes for accessibility
    toast.setAttribute('role', 'alert');
    toast.setAttribute('aria-live', 'assertive');
    toast.setAttribute('aria-atomic', 'true');
    toast.setAttribute('aria-hidden', 'true');
    toast.setAttribute('inert', '');

    // Icon HTML templates (all icons included, CSS shows appropriate one based on type)
    const iconHTML = `
      <div class="snotify-icon-error" style="display: none;">
        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 128 128">
          <g><g><path d="M64,0C28.7,0,0,28.7,0,64s28.7,64,64,64s64-28.7,64-64S99.3,0,64,0z M64,120C33.1,120,8,94.9,8,64S33.1,8,64,8s56,25.1,56,56S94.9,120,64,120z"/></g></g>
          <path d="M41.4,91.1C41.4,91.1,41.4,91.1,41.4,91.1c1.2,0,2.3-0.5,3.2-1.3L64,70.4l19.4,19.4c0.9,0.8,2,1.3,3.2,1.3c0,0,0,0,0,0c1.2,0,2.3-0.5,3.2-1.3c0.9-0.9,1.3-2,1.3-3.2c0-1.2-0.5-2.3-1.3-3.2L70.4,64l19.4-19.4c0.9-0.9,1.3-2,1.3-3.2c0-1.2-0.5-2.3-1.3-3.2c-0.9-0.9-2-1.3-3.2-1.3c0,0,0,0,0,0c-1.2,0-2.3,0.5-3.2,1.3L64,57.6L44.6,38.2c-0.9-0.9-2-1.3-3.2-1.3c0,0,0,0,0,0c-1.2,0-2.3,0.5-3.2,1.3c-0.9,0.9-1.3,2-1.3,3.2c0,1.2,0.5,2.3,1.3,3.2L57.6,64L38.2,83.4c-0.9,0.9-1.3,2-1.3,3.2c0,1.2,0.5,2.3,1.3,3.2C39,90.7,40.2,91.1,41.4,91.1z"/>
        </svg>
      </div>
      <div class="snotify-icon-info" style="display: none;">
        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26 26">
          <g><g><path d="M13,26C5.8,26,0,20.2,0,13S5.8,0,13,0s13,5.8,13,13S20.2,26,13,26z M13,2C6.9,2,2,6.9,2,13s4.9,11,11,11s11-4.9,11-11S19.1,2,13,2z"/></g></g>
          <path d="M11.8,18.9h2.4v-7.1h-2.4V18.9L11.8,18.9z M11.8,9.5h2.4V7.1h-2.4V9.5L11.8,9.5z"/>
        </svg>
      </div>
      <div class="snotify-icon-warning" style="display: none;">
        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 19.7 19.7">
          <g><path d="M9.8,3.1c0.6,0,1.1,0.4,1.5,1.1l5.9,9.9c0.9,1.4,0.2,2.6-1.5,2.6h-12c-1.7,0-2.3-1.2-1.5-2.6l5.9-9.9C8.7,3.4,9.3,3.1,9.8,3.1 M9.8,1.1c-1.3,0-2.5,0.7-3.3,2L0.7,13c-0.8,1.3-0.9,2.7-0.2,3.8s1.9,1.8,3.4,1.8h12c1.5,0,2.8-0.6,3.4-1.8s0.6-2.5-0.2-3.8l-5.9-9.9C12.3,1.8,11.1,1.1,9.8,1.1z"/></g>
          <g><circle cx="9.8" cy="13.6" r="1.3"/></g>
          <g><path d="M11.3,7.6c0-0.8-0.7-1.5-1.5-1.5S8.3,6.7,8.3,7.6c0,0.2,0,0.4,0.1,0.6c0.6,1.4,1.4,3.4,1.4,3.4s0.8-2.1,1.4-3.4C11.3,8,11.3,7.8,11.3,7.6z"/></g>
        </svg>
      </div>
      <div class="snotify-icon-success" style="display: none;">
        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26 26">
          <g><g><path d="M12.2,16.7c-0.3,0-0.5-0.1-0.7-0.3L9,14c-0.4-0.4-0.4-1,0-1.4s1-0.4,1.4,0l1.8,1.8L17,9.5c0.4-0.4,1-0.4,1.4,0s0.4,1,0,1.4l-5.5,5.5C12.7,16.7,12.4,16.7,12.2,16.7z"/></g>
          <g><path d="M13,26C5.8,26,0,20.2,0,13S5.8,0,13,0s13,5.8,13,13S20.2,26,13,26z M13,2C6.9,2,2,6.9,2,13s4.9,11,11,11s11-4.9,11-11S19.1,2,13,2z"/></g></g>
        </svg>
      </div>
    `;

    // Set innerHTML with toast structure
    toast.innerHTML = `
      <div class="snotifyToast" role="dialog" aria-labelledby="snotifyToast__title" aria-describedby="snotifyToast__body">
        <div class="snotifyToast-dialog">
          <div class="snotifyToast__progressBar">
            <span class="snotifyToast__progressBar__percentage" data-toast-pr></span>
          </div>
          <div class="snotifyToast__inner">
            <div class="snotify-icon">
              ${iconHTML}
            </div>
            <div class="snotifyToast__content">
              <div class="snotifyToast__title" id="snotifyToast__title"></div>
              <div class="snotifyToast__body" id="snotifyToast__body"></div>
            </div>
            <button type="button" class="snotifyToast__close snotifyToast__buttons--bold" aria-label="Close toast notification"></button>
          </div>
        </div>
      </div>
    `;

    // Note: _initializeElements() will be called automatically in connectedCallback
    // after the element is appended to the DOM

    return toast;
  }

  /**
   * Update CSS custom properties for toast positioning
   * Used for potential future stacking animations or z-index management
   * @private
   */
  _updatePositions() {
    // Set CSS custom property for each toast's index
    // This can be used for z-index or transform calculations if needed
    this.toasts.forEach((toast, index) => {
      if (toast && toast.style) {
        toast.style.setProperty('--toast-index', index);
      }
    });
  }

  /**
   * Remove toast from tracking array
   * Called by toast instance when it hides itself
   * @param {ToastNotification} toast - The toast instance to remove
   */
  removeToast(toast) {
    const index = this.toasts.indexOf(toast);
    if (index > -1) {
      this.toasts.splice(index, 1);
      // Update positions after removal
      this._updatePositions();
    }
  }

  /**
   * Hide all active toast notifications
   * @returns {ToastContainer} Returns this for method chaining
   */
  hideAll() {
    // Create a copy of the array to avoid issues during iteration
    // (toasts may remove themselves from array during hide())
    const toastsCopy = [...this.toasts];
    
    // Hide each toast
    toastsCopy.forEach((toast) => {
      if (toast && typeof toast.hide === 'function') {
        toast.hide();
      }
    });
    
    // Clear the array
    this.toasts = [];
    
    return this;
  }

  /**
   * Backward compatibility method - Alias for show()
   * @param {string} title - Notification title text
   * @param {string} body - Notification body text
   * @param {object} options - Configuration options
   * @returns {ToastContainer} Returns this for method chaining
   */
  updateNotification(title, body, options = {}) {
    this.show(title, body, options);
    return this;
  }

  /**
   * Hide the most recent toast notification
   * Backward compatibility method
   * @returns {ToastContainer} Returns this for method chaining
   */
  hide() {
    if (this.toasts.length > 0) {
      const lastToast = this.toasts[this.toasts.length - 1];
      if (lastToast && typeof lastToast.hide === 'function') {
        lastToast.hide();
      }
    }
    return this;
  }
}

// Register custom elements
customElements.define('toast-notification', ToastNotification);
customElements.define('toast-container', ToastContainer);

/**
 * Initialize the global toast notification container
 * Sets up window.notificationEle for global access
 */
const initToastContainer = () => {
  // Try to find existing container in DOM
  const container = Utility.DomSelector.$('toast-container');
  
  if (container) {
    // Use existing container
    window.notificationEle = container;
  } else {
    // Fallback: create container if it doesn't exist in DOM
    const fallbackContainer = document.createElement('toast-container');
    fallbackContainer.setAttribute('role', 'region');
    fallbackContainer.setAttribute('aria-label', 'Toast notifications');
    fallbackContainer.setAttribute('aria-live', 'polite');
    document.body.appendChild(fallbackContainer);
    window.notificationEle = fallbackContainer;
  }
};

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initToastContainer);
} else {
  // DOM already loaded, initialize immediately
  initToastContainer();
}

/**
 * Theme Header Component
 * Manages header functionality including mobile navigation toggle and sticky behavior
 * @extends HTMLElement
 */
class ThemeHeader extends HTMLElement {
  constructor() {
    super();
    
    // DOM element references
    this.mobileMenuToggle = null;
    this.mobileNavDrawer = null;
    this.header = this.closest('header') || this;
    
    // Sticky header state
    this.stickyType = this.getAttribute('data-sticky-type') || 'none';
    this.headerIsAlwaysSticky = this.stickyType === 'always';
    this.headerBounds = null;
    this.currentScrollTop = 0;
    this.animationFrame = null;
    this.observer = null;
    
    // State
    this.isMenuOpen = false;
    
    // Bind methods
    this.handleMenuToggle = this.handleMenuToggle.bind(this);
    this.handleDrawerClose = this.handleDrawerClose.bind(this);
    this.onScrollHandler = this.onScroll.bind(this);
    this.handleScroll = this.handleScroll.bind(this);
  }

  /**
   * Lifecycle callback - Called when element is added to DOM
   */
  connectedCallback() {
    // Find mobile menu toggle button
    this.mobileMenuToggle = Utility.DomSelector.$('[data-mobile-menu-toggle]', this);
    
    // Find mobile navigation drawer
    const drawerId = this.mobileMenuToggle?.getAttribute('data-toggleDrawer') || 
                     this.mobileMenuToggle?.getAttribute('data-mobile-menu-toggle');
    if (drawerId) {
      this.mobileNavDrawer = Utility.DomSelector.byId(drawerId) || 
                             Utility.DomSelector.$(`#${drawerId}`);
    }
    
    // Bind events
    if (this.mobileMenuToggle) {
      this.mobileMenuToggle.addEventListener('click', this.handleMenuToggle);
      this.mobileMenuToggle.setAttribute('aria-expanded', 'false');
      this.mobileMenuToggle.setAttribute('aria-controls', drawerId || 'mobile-nav-drawer');
    }
    
    // Listen for drawer close events
    if (this.mobileNavDrawer) {
      this.mobileNavDrawer.addEventListener('drawer:closed', this.handleDrawerClose);
    }
    
    // Initialize desktop navigation dropdowns
    this.initDesktopDropdowns();
    
    // Initialize sticky header if enabled
    if (this.stickyType !== 'none') {
      this.initStickyHeader();
    }
  }

  /**
   * Lifecycle callback - Called when element is removed from DOM
   */
  disconnectedCallback() {
    if (this.mobileMenuToggle) {
      this.mobileMenuToggle.removeEventListener('click', this.handleMenuToggle);
    }
    
    if (this.mobileNavDrawer) {
      this.mobileNavDrawer.removeEventListener('drawer:closed', this.handleDrawerClose);
    }
    
    // Cleanup sticky header
    if (this.stickyType !== 'none') {
      this.cleanupStickyHeader();
    }
  }

  /**
   * Initialize sticky header functionality
   */
  initStickyHeader() {
    if (!this.header) return;
    
    // Set initial scroll position
    this.currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
    
    // Add sticky class to header
    Utility.CSS.add(this.header, 'header-sticky');
    
    // If always sticky, just add the class and return
    if (this.headerIsAlwaysSticky) {
      return;
    }
    
    // For on-scroll-up mode, set up scroll listener and observer
    this.createObserver();
    window.addEventListener('scroll', this.onScrollHandler, { passive: true });
  }

  /**
   * Cleanup sticky header listeners
   */
  cleanupStickyHeader() {
    window.removeEventListener('scroll', this.onScrollHandler);
    
    if (this.animationFrame) {
      cancelAnimationFrame(this.animationFrame);
      this.animationFrame = null;
    }
    
    if (this.observer && this.header) {
      this.observer.disconnect();
      this.observer = null;
    }
  }

  /**
   * Create Intersection Observer to track header bounds
   */
  createObserver() {
    if (!this.header || !window.IntersectionObserver) return;
    
    this.observer = new IntersectionObserver((entries) => {
      if (entries[0]) {
        this.headerBounds = entries[0].boundingClientRect;
      }
    }, {
      threshold: [0, 1]
    });
    
    this.observer.observe(this.header);
    
    // Set initial bounds
    if (this.header) {
      this.headerBounds = this.header.getBoundingClientRect();
    }
  }

  /**
   * Handle scroll event with requestAnimationFrame optimization
   */
  onScroll() {
    if (!this.animationFrame) {
      this.animationFrame = requestAnimationFrame(() => {
        this.handleScroll();
        this.animationFrame = null;
      });
    }
  }

  /**
   * Process scroll position and update header state
   */
  handleScroll() {
    if (!this.header || this.headerIsAlwaysSticky) return;
    
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const headerHeight = this.headerBounds?.height || this.header.offsetHeight;
    
    // At page top - reset to normal position
    if (scrollTop <= headerHeight) {
      this.reset();
    } 
    // Scrolling down - hide header
    else if (scrollTop > this.currentScrollTop && scrollTop > headerHeight) {
      this.hide();
    } 
    // Scrolling up - reveal header
    else if (scrollTop < this.currentScrollTop && scrollTop > headerHeight) {
      this.reveal();
    }
    
    this.currentScrollTop = scrollTop;
  }

  /**
   * Hide header on scroll down
   */
  hide() {
    if (!this.header) return;
    Utility.CSS.add(this.header, 'header-hidden');
    Utility.CSS.remove(this.header, 'animate');
    this.dispatchEvent(new CustomEvent('header:hidden', { bubbles: true }));
  }

  /**
   * Reveal header on scroll up
   */
  reveal() {
    if (!this.header) return;
    Utility.CSS.remove(this.header, 'header-hidden');
    Utility.CSS.add(this.header, 'animate');
    this.dispatchEvent(new CustomEvent('header:revealed', { bubbles: true }));
  }

  /**
   * Reset header to normal position
   */
  reset() {
    if (!this.header) return;
    Utility.CSS.remove(this.header, 'header-hidden', 'animate');
    this.dispatchEvent(new CustomEvent('header:reset', { bubbles: true }));
  }

  /**
   * Initialize desktop navigation dropdowns
   * Supports hover for desktop and click for touch devices
   */
  initDesktopDropdowns() {
    const dropdowns = Utility.DomSelector.$$('[data-nav-dropdown]', this);
    
    // Detect touch device
    const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
    
    // Helper function to close all dropdowns except the specified one
    const closeOtherDropdowns = (currentDropdown) => {
      dropdowns.forEach(otherDropdown => {
        if (otherDropdown !== currentDropdown) {
          Utility.CSS.remove(otherDropdown, 'open');
          const otherLink = otherDropdown.querySelector('[data-nav-link-parent]');
          if (otherLink) {
            otherLink.setAttribute('aria-expanded', 'false');
          }
        }
      });
    };
    
    // Helper function to close all nested dropdowns
    const closeAllNestedDropdowns = () => {
      dropdowns.forEach(dropdown => {
        const nestedDropdowns = dropdown.querySelectorAll('[data-nav-dropdown-nested]');
        nestedDropdowns.forEach(nestedDropdown => {
          Utility.CSS.remove(nestedDropdown, 'open');
          const nestedLink = nestedDropdown.querySelector('[data-nav-link-parent]');
          if (nestedLink) {
            nestedLink.setAttribute('aria-expanded', 'false');
          }
        });
      });
    };
    
    dropdowns.forEach(dropdown => {
      const link = dropdown.querySelector('[data-nav-link-parent]');
      const menu = dropdown.querySelector('[data-nav-dropdown-menu]');
      
      if (!link || !menu) return;
      
      // Set initial aria attributes
      link.setAttribute('aria-haspopup', 'true');
      link.setAttribute('aria-expanded', 'false');
      menu.setAttribute('role', 'menu');
      const menuId = `nav-menu-${Math.random().toString(36).substr(2, 9)}`;
      menu.setAttribute('id', menuId);
      link.setAttribute('aria-controls', menuId);
      
      menu.querySelectorAll('[data-nav-link]').forEach(item => {
        item.setAttribute('role', 'menuitem');
      });
      
      if (isTouchDevice) {
        // Touch devices: Use click/tap
        link.addEventListener('click', (e) => {
          const isOpen = dropdown.classList.contains('open');
          
          if (isOpen) {
            // If already open, allow navigation to parent link
            // Don't prevent default - let the link navigate
            Utility.CSS.remove(dropdown, 'open');
            link.setAttribute('aria-expanded', 'false');
            closeAllNestedDropdowns();
          } else {
            // If closed, open dropdown and prevent navigation
            e.preventDefault();
            closeOtherDropdowns(dropdown);
            closeAllNestedDropdowns();
            Utility.CSS.add(dropdown, 'open');
            link.setAttribute('aria-expanded', 'true');
          }
        });
      } else {
        // Desktop: Use hover
        dropdown.addEventListener('mouseenter', () => {
          closeOtherDropdowns(dropdown);
          closeAllNestedDropdowns();
          Utility.CSS.add(dropdown, 'open');
          link.setAttribute('aria-expanded', 'true');
        });
        
        dropdown.addEventListener('mouseleave', () => {
          Utility.CSS.remove(dropdown, 'open');
          link.setAttribute('aria-expanded', 'false');
          closeAllNestedDropdowns();
        });
      }
      
      // Handle keyboard navigation (works for both desktop and touch)
      link.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          const isOpen = dropdown.classList.contains('open');
          if (isOpen) {
            Utility.CSS.remove(dropdown, 'open');
            link.setAttribute('aria-expanded', 'false');
            closeAllNestedDropdowns();
          } else {
            closeOtherDropdowns(dropdown);
            closeAllNestedDropdowns();
            Utility.CSS.add(dropdown, 'open');
            link.setAttribute('aria-expanded', 'true');
          }
        } else if (e.key === 'Escape') {
          Utility.CSS.remove(dropdown, 'open');
          link.setAttribute('aria-expanded', 'false');
          closeAllNestedDropdowns();
          link.focus();
        }
      });
      
      // Handle nested dropdowns
      const nestedDropdowns = dropdown.querySelectorAll('[data-nav-dropdown-nested]');
      nestedDropdowns.forEach(nestedDropdown => {
        const nestedLink = nestedDropdown.querySelector('[data-nav-link-parent]');
        const nestedMenu = nestedDropdown.querySelector('[data-nav-dropdown-menu-nested]');
        
        if (nestedLink && nestedMenu) {
          nestedLink.setAttribute('aria-haspopup', 'true');
          nestedLink.setAttribute('aria-expanded', 'false');
          const nestedMenuId = `nav-menu-nested-${Math.random().toString(36).substr(2, 9)}`;
          nestedMenu.setAttribute('id', nestedMenuId);
          nestedLink.setAttribute('aria-controls', nestedMenuId);
          nestedMenu.setAttribute('role', 'menu');
          nestedMenu.querySelectorAll('[data-nav-link]').forEach(item => {
            item.setAttribute('role', 'menuitem');
          });
          
          if (isTouchDevice) {
            // Touch devices: Use click/tap for nested
            nestedLink.addEventListener('click', (e) => {
              e.stopPropagation(); // Prevent parent dropdown from closing
              const isOpen = nestedDropdown.classList.contains('open');
              
              if (isOpen) {
                // If already open, allow navigation to nested link
                // Don't prevent default - let the link navigate
                Utility.CSS.remove(nestedDropdown, 'open');
                nestedLink.setAttribute('aria-expanded', 'false');
              } else {
                // If closed, open nested dropdown and prevent navigation
                e.preventDefault();
                // Close other nested dropdowns in the same parent
                nestedDropdowns.forEach(otherNested => {
                  if (otherNested !== nestedDropdown) {
                    Utility.CSS.remove(otherNested, 'open');
                    const otherNestedLink = otherNested.querySelector('[data-nav-link-parent]');
                    if (otherNestedLink) {
                      otherNestedLink.setAttribute('aria-expanded', 'false');
                    }
                  }
                });
                Utility.CSS.add(nestedDropdown, 'open');
                nestedLink.setAttribute('aria-expanded', 'true');
              }
            });
          } else {
            // Desktop: Use hover for nested
            nestedDropdown.addEventListener('mouseenter', () => {
              // Close other nested dropdowns in the same parent
              nestedDropdowns.forEach(otherNested => {
                if (otherNested !== nestedDropdown) {
                  Utility.CSS.remove(otherNested, 'open');
                  const otherNestedLink = otherNested.querySelector('[data-nav-link-parent]');
                  if (otherNestedLink) {
                    otherNestedLink.setAttribute('aria-expanded', 'false');
                  }
                }
              });
              Utility.CSS.add(nestedDropdown, 'open');
              nestedLink.setAttribute('aria-expanded', 'true');
            });
            
            nestedDropdown.addEventListener('mouseleave', () => {
              Utility.CSS.remove(nestedDropdown, 'open');
              nestedLink.setAttribute('aria-expanded', 'false');
            });
          }
        }
      });
    });
    
    // Close dropdowns when clicking outside (works for both desktop and touch)
    document.addEventListener('click', (e) => {
      if (!e.target.closest('[data-nav-dropdown]')) {
        dropdowns.forEach(dropdown => {
          Utility.CSS.remove(dropdown, 'open');
          const link = dropdown.querySelector('[data-nav-link-parent]');
          if (link) {
            link.setAttribute('aria-expanded', 'false');
          }
        });
        closeAllNestedDropdowns();
      }
    });
  }

  /**
   * Handle mobile menu toggle button click
   * @param {Event} event - Click event
   */
  handleMenuToggle(event) {
    event.preventDefault();
    
    if (!this.mobileNavDrawer) {
      console.warn('ThemeHeader: Mobile navigation drawer not found');
      return;
    }
    
    // Toggle menu state
    this.isMenuOpen = !this.isMenuOpen;
    
    // Update button aria-expanded
    if (this.mobileMenuToggle) {
      this.mobileMenuToggle.setAttribute('aria-expanded', this.isMenuOpen.toString());
    }
    
    // Open or close drawer
    if (this.isMenuOpen) {
      if (typeof this.mobileNavDrawer.openDrawer === 'function') {
        this.mobileNavDrawer.openDrawer(this.mobileMenuToggle);
      } else {
        // Fallback if CustomDrawer methods don't exist
        Utility.CSS.add(this.mobileNavDrawer, 'open');
        this.mobileNavDrawer.setAttribute('aria-hidden', 'false');
        this.mobileNavDrawer.removeAttribute('inert');
        SiteOverlay.showOverlay();
        
        // Announce to screen reader
        const drawerName = this.mobileNavDrawer.getAttribute('aria-label') || 'Mobile navigation';
        Utility.announceToScreenReader(`${drawerName} drawer opened`);
      }
    } else {
      if (typeof this.mobileNavDrawer.closeDrawer === 'function') {
        this.mobileNavDrawer.closeDrawer();
      } else {
        // Fallback if CustomDrawer methods don't exist
        Utility.CSS.remove(this.mobileNavDrawer, 'open');
        this.mobileNavDrawer.setAttribute('aria-hidden', 'true');
        this.mobileNavDrawer.setAttribute('inert', '');
        SiteOverlay.hideOverlay();
        
        // Announce to screen reader
        const drawerName = this.mobileNavDrawer.getAttribute('aria-label') || 'Mobile navigation';
        Utility.announceToScreenReader(`${drawerName} drawer closed`);
      }
    }
  }

  /**
   * Handle drawer close event
   * Updates button state when drawer is closed externally
   */
  handleDrawerClose() {
    this.isMenuOpen = false;
    if (this.mobileMenuToggle) {
      this.mobileMenuToggle.setAttribute('aria-expanded', 'false');
    }
  }
}

// Register custom element
customElements.define('theme-header', ThemeHeader);

/**
 * Mobile Navigation Component
 * Handles slide-in submenu navigation from right to left
 * @extends HTMLElement
 */
class MobileNavigation extends HTMLElement {
  constructor() {
    super();
    
    this.currentLevel = 'main';
    this.navLevels = [];
    this.toggleButtons = [];
    this.backButtons = [];
    this.accordionButtons = [];
    
    // Bind methods
    this.handleToggle = this.handleToggle.bind(this);
    this.handleBack = this.handleBack.bind(this);
    this.handleAccordionToggle = this.handleAccordionToggle.bind(this);
  }

  connectedCallback() {
    // Find all navigation levels
    this.navLevels = Utility.DomSelector.$$('.mobile-nav-level', this);
    
    // Find all toggle buttons
    this.toggleButtons = Utility.DomSelector.$$('[data-mobile-nav-toggle]', this);
    
    // Find all back buttons
    this.backButtons = Utility.DomSelector.$$('[data-mobile-nav-back]', this);
    
    // Find all accordion toggle buttons
    this.accordionButtons = Utility.DomSelector.$$('[data-accordion-toggle]', this);
    
    // Bind toggle buttons
    this.toggleButtons.forEach(button => {
      button.addEventListener('click', this.handleToggle);
    });
    
    // Bind back buttons
    this.backButtons.forEach(button => {
      button.addEventListener('click', this.handleBack);
    });
    
    // Bind accordion buttons
    this.accordionButtons.forEach(button => {
      button.addEventListener('click', this.handleAccordionToggle);
    });
    
    // Initialize - show main level only
    this.showLevel('main');
  }

  disconnectedCallback() {
    this.toggleButtons.forEach(button => {
      button.removeEventListener('click', this.handleToggle);
    });
    
    this.backButtons.forEach(button => {
      button.removeEventListener('click', this.handleBack);
    });
    
    this.accordionButtons.forEach(button => {
      button.removeEventListener('click', this.handleAccordionToggle);
    });
  }

  /**
   * Handle submenu toggle - slide in from right
   * @param {Event} event - Click event
   */
  handleToggle(event) {
    event.preventDefault();
    const button = event.currentTarget;
    const targetLevel = button.getAttribute('data-target-level');
    
    if (!targetLevel) return;
    
    // Update button aria-expanded
    button.setAttribute('aria-expanded', 'true');
    
    // Show target level
    this.showLevel(targetLevel);
    
    // Announce to screen reader
    const levelTitle = button.querySelector('span')?.textContent || 'Submenu';
    Utility.announceToScreenReader(`${levelTitle} submenu opened`);
  }

  /**
   * Handle back button - return to previous level
   * @param {Event} event - Click event
   */
  handleBack(event) {
    event.preventDefault();
    
    // Find current active level
    const currentLevel = Utility.DomSelector.$('.mobile-nav-level.active', this);
    if (!currentLevel) return;
    
    // Reset toggle button that opened this level
    const currentLevelId = currentLevel.getAttribute('data-nav-level');
    const toggleButton = Utility.DomSelector.$(`[data-target-level="${currentLevelId}"]`, this);
    if (toggleButton) {
      toggleButton.setAttribute('aria-expanded', 'false');
    }
    
    // Return to main level
    this.showLevel('main');
    
    // Announce to screen reader
    Utility.announceToScreenReader('Returned to main menu');
  }

  /**
   * Show specific navigation level
   * @param {string} levelId - Level identifier (main, child-X, etc.)
   */
  showLevel(levelId) {
    // Hide all levels
    this.navLevels.forEach(level => {
      Utility.CSS.remove(level, 'active');
    });
    
    // Show target level
    const targetLevel = Utility.DomSelector.$(`[data-nav-level="${levelId}"]`, this);
    if (targetLevel) {
      Utility.CSS.add(targetLevel, 'active');
      this.currentLevel = levelId;
      
      // Focus first link in the new level
      const firstLink = Utility.DomSelector.$('a, button', targetLevel);
      if (firstLink && typeof firstLink.focus === 'function') {
        setTimeout(() => firstLink.focus(), 100);
      }
    }
  }

  /**
   * Handle accordion toggle - expand/collapse third level menu
   * @param {Event} event - Click event
   */
  handleAccordionToggle(event) {
    event.preventDefault();
    event.stopPropagation();
    
    const button = event.currentTarget;
    const accordionItem = button.closest('[data-accordion-item]');
    const content = Utility.DomSelector.$('.accordion-content', accordionItem);
    
    if (!accordionItem || !content) return;
    
    const isOpen = accordionItem.classList.contains('open');
    
    if (isOpen) {
      // Close this accordion
      this.closeAccordion(accordionItem, button, content);
    } else {
      // Close other open accordions in the same level (accordion behavior)
      const currentLevel = accordionItem.closest('.mobile-nav-level');
      if (currentLevel) {
        const openAccordions = Utility.DomSelector.$$('[data-accordion-item].open', currentLevel);
        openAccordions.forEach(item => {
          if (item !== accordionItem) {
            const itemButton = Utility.DomSelector.$('[data-accordion-toggle]', item);
            const itemContent = Utility.DomSelector.$('.accordion-content', item);
            if (itemButton && itemContent) {
              this.closeAccordion(item, itemButton, itemContent);
            }
          }
        });
      }
      
      // Open this accordion
      this.openAccordion(accordionItem, button, content);
    }
  }

  /**
   * Open accordion
   * @param {HTMLElement} accordionItem - Accordion container
   * @param {HTMLElement} button - Toggle button
   * @param {HTMLElement} content - Content element
   */
  openAccordion(accordionItem, button, content) {
    Utility.CSS.add(accordionItem, 'open');
    button.setAttribute('aria-expanded', 'true');
    content.setAttribute('aria-hidden', 'false');
    content.removeAttribute('inert');
  }

  /**
   * Close accordion
   * @param {HTMLElement} accordionItem - Accordion container
   * @param {HTMLElement} button - Toggle button
   * @param {HTMLElement} content - Content element
   */
  closeAccordion(accordionItem, button, content) {
    Utility.CSS.remove(accordionItem, 'open');
    button.setAttribute('aria-expanded', 'false');
    content.setAttribute('aria-hidden', 'true');
    content.setAttribute('inert', '');
  }

  /**
   * Reset to main level (called when drawer closes)
   */
  reset() {
    this.showLevel('main');
    
    // Reset all toggle buttons
    this.toggleButtons.forEach(button => {
      button.setAttribute('aria-expanded', 'false');
    });
    
    // Close all accordions
    const openAccordions = Utility.DomSelector.$$('[data-accordion-item].open', this);
    openAccordions.forEach(accordionItem => {
      const button = Utility.DomSelector.$('[data-accordion-toggle]', accordionItem);
      const content = Utility.DomSelector.$('.accordion-content', accordionItem);
      if (button && content) {
        this.closeAccordion(accordionItem, button, content);
      }
    });
  }
}

// Register custom element
customElements.define('mobile-navigation', MobileNavigation);

// Initialize mobile navigation when drawer opens/closes
document.addEventListener('drawer:opened', (event) => {
  if (event.target.id === 'mobile-nav-drawer') {
    const mobileNav = Utility.DomSelector.$('mobile-navigation', event.target);
    if (mobileNav && typeof mobileNav.reset === 'function') {
      mobileNav.reset();
    }
  }
});

document.addEventListener('drawer:closed', (event) => {
  if (event.target.id === 'mobile-nav-drawer') {
    const mobileNav = Utility.DomSelector.$('mobile-navigation', event.target);
    if (mobileNav && typeof mobileNav.reset === 'function') {
      mobileNav.reset();
    }
  }
});